<template>
    <div class="generic-modal-container" v-if="!hidden" @click="bgClicked" :class="{
        opened: !hidden,
        'bg-clip-padding bg-gray-50 backdrop-filter bg-opacity-50': !hidden,
        opaque: isOpaque
    }">
        <div class="generic-modal">
            <div class="overflow-hidden" style="height: 75vh">
                <div class="mt-2">
                    <div class="relative h-full w-full">
                        <heading size="medium" class="absolute" style="top:0px">Notes <span class="text-gray-300 font-medium font-weight-normal text-sm mt-0 ml-2"><span class="far fa-keyboard mr-1"></span>Q</span></heading>
                        <main ref="notescontainer" class="flex flex-col mt-2 overflow-y-auto overflow-x-hidden absolute w-full"
                              style="top:30px; bottom:80px;">
                            <div v-for="note in notes" :key="note.id" class="max-w-md mb-4"
                                 :class="note.created_by.is_you ? 'ml-8 self-end mr-3' : 'mr-8 self-start'">
                                <div
                                    class="rounded-xl border p-3 flex flex-row last:mb-0 max-w-md"
                                    :class="{
                        'bg-brand border-brand-dark text-white': note.created_by.is_you,
                        'bg-gray-50 border-gray-300 text-brand': ! note.created_by.is_you
                    }"
                                >
                                    <div class="mr-3 flex-shrink-0">
                                        <img
                                            class="rounded h-6 w-6"
                                            :src="(note.created_by || {}).avatar"
                                            onerror="this.src='/img/user-placeholder.png';this.onerror='';"
                                        />
                                    </div>
                                    <div>
                                        <h3 class="text-xs font-bold"
                                            :class="note.created_by.is_you ? 'text-white' : 'text-gray-700'"
                                            v-text="note.created_by.name"></h3>
                                        <div class="whitespace-pre-wrap"
                                             :class="note.created_by.is_you ? 'text-white' : 'text-gray-700'"
                                             v-text="note.note"></div>
                                    </div>
                                </div>
                                <div :class="note.created_by.is_you ? 'text-right' : 'text-left'"
                                     class="mt-1.5 text-xs">
                                    <span class="inline-block text-gray-400 hover:text-gray-500 cursor-pointer"
                                          :title="note.created_at_formatted">{{ note.created_at_human }}</span>
                                </div>
                            </div>
                        </main>
                        <aside class="mt-6 absolute w-full" style="bottom:24px;">
                            <div class="mt-1 flex rounded-md shadow-sm">
                                <div class="relative flex items-stretch flex-grow focus-within:z-10">
                                    <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <img
                                            class="rounded w-6 h-6"
                                            :src="avatar_url"
                                            onerror="this.src='/img/user-placeholder.png';this.onerror='';"
                                        />
                                    </div>
                                    <input
                                        v-model="note"
                                        type="text"
                                        class="focus:ring-brand focus:border-brand block w-full mb-0 rounded-none rounded-l-md pl-12 sm:text-sm border-gray-300"
                                        placeholder="Enter note here..."
                                        @keyup.enter="addNote()"
                                    >
                                </div>
                                <button @click.prevent="addNote()"
                                        class="-ml-px relative inline-flex items-center space-x-2 px-4 py-1 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
                                    <i class="fas fa-caret-right"></i>
                                    <span>Send</span>
                                </button>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import _ from "lodash";
import Notes from "../Notes.vue";
import Heading from "../ui/Heading.vue";

export default {
    components: {Heading, Notes},
    props: {
        isOpaque: true,
        packageReference: false,
        legacyPackageId: false,
    },
    data() {
        return {
            hidden: true,
            items: [],
            getUrl: route('api.v1.packages.notes.index', this.legacyPackageId),
            postUrl: route('api.v1.packages.notes.store', this.legacyPackageId),
            notes: [],
            note: '',
        }
    },
    computed: {
        avatar_url() {
            return appData.user.avatar_url;
        }
    },
    methods: {
        closeModal() {
            window.Bus.emit('close-package-notes')
            this.hidden = true;
        },
        openModal() {
            window.Bus.emit('close-all-slideovers');
            this.getNotes();
            this.hidden = false;
        },
        bgClicked(e) {
            if (e.target.classList.contains('generic-modal-container')) {
                this.closeModal();
            }
        },
        scrollToBottom() {
            this.$nextTick(() => {
                setTimeout(() => {
                        let container = this.$refs.notescontainer;
                        if (container) {
                            container.scrollTop = container.scrollHeight;
                        }
                    }, 10
                )
            });
        },
        addNote() {
            var that = this;
            var note = this.note;
            this.note = '';
            axios.post(this.postUrl, {note: note})
                .then(response => {
                    that.notes.push(response.data.data);
                    that.scrollToBottom();
                });
        }
        ,
        getNotes() {
            var that = this;
            axios.get(this.getUrl)
                .then(response => {
                    that.notes = response.data.data;
                    that.scrollToBottom();
                });
        }
    },
    async mounted() {
        window.Bus.on('show-package-notes', (reference) => {
            //YUK - copied from v1 contacts for now
            axios.get(appUrls.packages.contacts.index.replace('REPLACEME', this.legacyPackageId), {params: {group_by_letter: true}})
                .then(response => {
                    this.items = _.groupBy(_.sortBy(response.data.data, 'type'), function (contact) {
                        return contact.type;
                    });
                    this.openModal()
                });
        })
        window.Bus.on('close-all-slideovers', (reference) => {
            this.closeModal()
        })
        window.addEventListener('keydown', (e) => {
            if (e.ctrlKey || e.metaKey) {
                return;
            }
            if (e.keyCode === 27) {
                if (!this.hidden) {
                    this.closeModal()
                }
            }

            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(e.target.tagName)) {
                return;
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(document.activeElement.tagName)) {
                return;
            }

            if ((e.key === 'q') || (e.key === 'Q')) {
                e.preventDefault();
                e.stopPropagation();
                if (this.hidden) {
                    window.Bus.emit('show-package-notes', this.packageReference)
                } else {
                    this.closeModal();
                }
            }
        })
        window.addEventListener('resize', (e) => {
            if (window.innerWidth <= 830) {
                if (!this.hidden) {
                    this.closeModal();
                }
            }
        })
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/setup';

.generic-modal-container {
    display: none;

    &.opened {
        position: absolute;
        min-height: 100vh;
        width: 100vw;
        z-index: 100000;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        padding: 2em;
        @include desktop() {
            &.opaque {
                background-color: rgba(255, 255, 255, 1);
            }
        }
    }
}

.generic-modal {
    padding: 1em;
    @include grid-column(12);
    @include clearfix();
    @include desktop() {
        background-color: #fff;
        border-radius: 0.5em;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
        @include grid-column(8);
        max-width: 1024px;
        padding: 2em;
    }

    div.actions {
        text-align: left;
        margin-top: 30px;

        a, input[type="submit"] {
            padding: 0.7em 0.7em 0.8em;
            text-decoration: none;
            color: #fff;
            border-radius: $standardBorderRadius;
        }

        input[type="submit"] {
            background-color: $green;
        }

        a {
            background-color: #999;
        }

        a.success {
            background-color: $green;
        }

        @include desktop() {
            float: right;
            text-align: right;
        }
    }
}

li.contact {
    margin: 1em 0;
}

.meta, .name {
    @include clearfix();

    small {
        float: right;
        text-align: right;
    }
}

.name small {
    opacity: 0.5;
}

.meta {
    font-size: 0.8em;
    opacity: 0.5;

    small {
        font-size: 1em;
    }
}

.person-meta, .company-meta {
    @include grid-column(6);
    @include mobile() {
        @include grid-column(12);
    }
}

.position {
    text-align: center;
    font-weight: 300;
    font-size: 2em;
    margin: 1em 0 2em;
}
</style>
